// Popisky EventType pro <select>
export const EVENT_TYPE_OPTIONS = [
  { title: 'Závody',        value: 'races' },
  { title: 'Soustředění',   value: 'camp' },
  { title: 'Trénink',       value: 'training' },
  { title: 'Ostatní',       value: 'other' },
  { title: 'Reprezentační', value: 'repre' },
  { title: 'SCM',           value: 'scm' },
  { title: 'Asociační',     value: 'association' },
]

// Popisky úrovní závodu
const ALL_LEVELS = {
 // INTERNATIONAL: { title: 'Mezinárodní závod', value: 'INTERNATIONAL' },
  NATIONAL:      { title: 'MČR/NŽ - I. stupeň',      value: 'NATIONAL' },
  REGIONAL:      { title: 'Soutěž II. stupně',   value: 'REGIONAL' },
  DISTRICT:      { title: 'Soutěž III. stupně',      value: 'DISTRICT' },
  TRAINING:      { title: 'Trénink',      value: 'TRAINING' },
  OTHER:         { title: 'Ostatní',      value: 'OTHER' },
  SELECTIONS:    { title: 'Nominační',     value: 'SELECTIONS' },
}

// Mapování povolených úrovní podle EventType
export const RACE_LEVEL_MAPPING = {
  // „races“, „camp“, „training“ i „other“ mají všechny úrovně
  races:       [
  //  ALL_LEVELS.INTERNATIONAL,
    ALL_LEVELS.NATIONAL,
    ALL_LEVELS.REGIONAL,
    ALL_LEVELS.DISTRICT,
    ALL_LEVELS.TRAINING,
    ALL_LEVELS.OTHER,
  ],
  camp:        [
   // ALL_LEVELS.INTERNATIONAL,
    ALL_LEVELS.NATIONAL,
    ALL_LEVELS.REGIONAL,
    ALL_LEVELS.DISTRICT,
    ALL_LEVELS.TRAINING,
    ALL_LEVELS.OTHER,
  ],
  training:    [
   // ALL_LEVELS.INTERNATIONAL,
    ALL_LEVELS.NATIONAL,
    ALL_LEVELS.REGIONAL,
    ALL_LEVELS.DISTRICT,
    ALL_LEVELS.TRAINING,
    ALL_LEVELS.OTHER,
  ],
  other:       [
  //  ALL_LEVELS.INTERNATIONAL,
    ALL_LEVELS.NATIONAL,
    ALL_LEVELS.REGIONAL,
    ALL_LEVELS.DISTRICT,
    ALL_LEVELS.TRAINING,
    ALL_LEVELS.OTHER,
  ],

  // „repre“ a „scm“ jen TRAINING, SELECTIONS, OTHER
  repre:       [
    ALL_LEVELS.TRAINING,
    ALL_LEVELS.SELECTIONS,
    ALL_LEVELS.OTHER,
  ],
  scm:         [
    ALL_LEVELS.TRAINING,
    ALL_LEVELS.SELECTIONS,
    ALL_LEVELS.OTHER,
  ],

  // „association“ jen TRAINING a OTHER
  association: [
    ALL_LEVELS.TRAINING,
    ALL_LEVELS.OTHER,
  ],
}